(() => {
 const init = root => {
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const choices = Array.from(root.querySelectorAll('[data-md-choice]'));
  const options = Array.from(root.querySelectorAll('[data-md-option]'));
  const cards = Array.from(root.querySelectorAll('[data-md-card]'));
  const status = root.querySelector('[data-md-status]');
  const filter = root.querySelector('[data-md-need]');
  const matches = option => {
   const d = option.dataset, price = Number(d.price) / 100, n = filter.value;
   return n === 'all' || (n === 'no-outlet' && d.electric === 'false') || (n === 'value' && d.electric === 'true' && price < 450) || (n === 'midrange' && d.electric === 'true' && price >= 450 && price < 650) || (n === 'premium' && d.electric === 'true' && price >= 650) || (n === 'round' && d.round === 'true') || ((n === 'remote' || n === 'sidearm') && d.control === n);
  };
  const render = () => {
   const selected = choices.filter(c => c.checked);
   cards.forEach(card => card.hidden = !selected.some(c => c.value === card.dataset.mdCard));
   choices.forEach(c => c.disabled = !c.checked && selected.length >= 3);
   status.textContent = selected.length ? selected.length + ' of 3 seats selected. Uncheck one to choose another.' : 'Select up to three seats to start comparing.';
  };
  choices.forEach(c => c.addEventListener('change', () => {
   if (choices.filter(x => x.checked).length > 3) c.checked = false;
   render();
  }));
  const applyFilter = () => {
   let count = 0;
   options.forEach(o => {
    const visible = matches(o);
    o.hidden = !visible;
    o.querySelector('input').checked = visible && count++ < 3;
   });
   render();
  };
  filter.addEventListener('change', applyFilter);
  const requested = new URLSearchParams(location.search).get('need');
  if (requested && Array.from(filter.options).some(o => o.value === requested)) { filter.value = requested; applyFilter(); } else { render(); }
 };
 document.querySelectorAll('[data-md-comparison]').forEach(init);
 document.addEventListener('shopify:section:load', event => init(event.target.querySelector('[data-md-comparison]')));
})();